// extracted by mini-css-extract-plugin
export default {"stepperPrecise":"style_stepperPrecise__mQ6ze","stepperPrecise_currentValue":"style_stepperPrecise_currentValue__h+H15"};